import { render, staticRenderFns } from "./BeneficiaryAccordian.vue?vue&type=template&id=6e27d3ad"
import script from "./BeneficiaryAccordian.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports